module.exports = __webpack_public_path__ + "static/full_product_development-ff299f8972c0068162deae04a1ede264.png";